/* Saltwater: tag sale colors with a "Sale" label above the swatch.
   Works on top of the combined-listings swatch app (.mpg-swatch), on product pages and product cards.
   A color counts as on sale when its product has a compare-at price above its price. */
(function () {
  var cache = {};
  function fetchSale(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return false;
          return p.variants.some(function (v) {
            return v.available && v.compare_at_price && v.compare_at_price > v.price;
          });
        })
        .catch(function () { return false; });
    }
    return cache[handle];
  }
  function appGroup(id) {
    var gs = window.mpg && window.mpg.groups;
    if (!gs) return null;
    var arr = Array.isArray(gs) ? gs : Object.keys(gs).map(function (k) { return gs[k]; });
    for (var i = 0; i < arr.length; i++) if (arr[i] && arr[i].id === id) return arr[i];
    return null;
  }
  /* Product cards: use the swatch app's own product data (no extra requests). */
  function cardSale(swatchRoot, opt) {
    var g = appGroup(swatchRoot.getAttribute('group-id'));
    if (!g || !g.products) return null;
    var vid = opt.getAttribute('v-id');
    var p = g.products.filter(function (x) { return x.options && x.options.indexOf(vid) > -1 && x.status === 'ACTIVE'; })[0];
    if (!p) return null;
    return !!(p.regular_price && p.sale_price && p.regular_price > p.sale_price);
  }
  /* Product page: check live prices. */
  function pageSale(opt) {
    var m = (opt.getAttribute('onclick') || '').match(/redirectToProductPage\('([^']+)'/);
    var h = m ? m[1] : (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    return h ? fetchSale(h) : Promise.resolve(false);
  }
  function saleItem(opt) {
    var w = document.createElement('div');
    w.className = 'sw-sale-item';
    var l = document.createElement('div');
    l.className = 'sw-sale-item__label';
    l.textContent = 'Sale';
    w.appendChild(l);
    w.appendChild(opt);
    return w;
  }
  function row(cls, items) {
    var r = document.createElement('div');
    r.className = 'sw-swatch-row ' + cls;
    items.forEach(function (i) { r.appendChild(i); });
    return r;
  }
  /* Full-price colors stay first with no label; every sale color gets its own "Sale" tag,
     on a second row when a style has both. */
  function split(nav, opts, flags) {
    var sale = [], full = [];
    opts.forEach(function (o, i) { (flags[i] ? sale : full).push(o); });
    if (!sale.length) { nav.setAttribute('data-sw-grouped', 'none'); return; }
    nav.classList.add('sw-swatch-grouped');
    if (full.length) nav.appendChild(row('sw-swatch-row--full', full));
    nav.appendChild(row('sw-swatch-row--sale', sale.map(saleItem)));
    nav.setAttribute('data-sw-grouped', 'done');
  }
  function apply(nav) {
    if (nav.getAttribute('data-sw-grouped')) return;
    var set = nav.closest('.mpg-swatch__option-set');
    var name = (nav.getAttribute('os-name') || (set && set.getAttribute('os-name')) || '').toLowerCase();
    if (name !== 'color' && name !== 'colour') return;
    var root = nav.closest('.mpg-swatch');
    if (!root) return;
    var opts = Array.prototype.slice.call(nav.querySelectorAll('.mpg-swatch__option'));
    if (opts.length < 2) return;
    if (root.classList.contains('mpg-card')) {
      var flags = opts.map(function (o) { return cardSale(root, o); });
      if (flags.some(function (f) { return f === null; })) return; /* app data not ready yet; try again later */
      nav.setAttribute('data-sw-grouped', 'done');
      nav.classList.add('sw-card');
      split(nav, opts, flags);
    } else {
      nav.setAttribute('data-sw-grouped', 'pending');
      Promise.all(opts.map(pageSale)).then(function (f) { split(nav, opts, f); });
    }
  }
  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.mpg-swatch .mpg-swatch__nav').forEach(apply);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }
  var css = document.createElement('style');
  css.textContent =
    '.mpg-swatch__nav.sw-swatch-grouped{display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important;gap:10px}' +
    '.sw-swatch-row{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:flex-start;width:100%;column-gap:8px;row-gap:8px}' +
    '.sw-sale-item{display:flex;flex-direction:column;align-items:center;gap:5px}' +
    '.sw-sale-item__label{font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#c0392b;line-height:1;white-space:nowrap}' +
    '.sw-card.sw-swatch-grouped{gap:6px}' +
    '.sw-card .sw-swatch-row{column-gap:5px;row-gap:5px}' +
    '.sw-card .sw-sale-item{gap:3px}' +
    '.sw-card .sw-sale-item__label{font-size:8px;letter-spacing:.08em}';
  document.head.appendChild(css);
  scan();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', queue);
  setTimeout(queue, 2000); setTimeout(queue, 5000);
})();
